export default "__VITE_ASSET__D3SPu7GO__"